import type { GlobalAlert } from '../api/globalAlerts.types';
import { filterAlerts, sortAlerts } from './globalAlertsUtils';

export const fetchGlobalAlerts = async (
  url: string,
  signal?: AbortSignal,
  currentEnv?: string
): Promise<Array<GlobalAlert>> => {
  if (!url) {
    throw new Error(`Could not fetch global alerts: no URL provided. Check assetUrls in app configuration.`);
  }

  // # nosemgrep
  const response = await fetch(url, {
    signal,
    cache: 'no-store'
  });

  if (!response.ok) throw new Error(`Global alerts fetch failed: ${response.status}`);

  const alerts: Array<GlobalAlert> = await response.json();
  return sortAlerts(filterAlerts(alerts, currentEnv));
};
